export default __webpack_public_path__ + "a95fd1391368be9949c070e40e6b0e2a.png";